<template>
  <el-drawer
    title="我是标题"
    :visible.sync="drawer"
    :with-header="false"
    :modal-append-to-body="false"
    direction="rtl"
    size="50%"
  >
    <div class="top_drawer">
      <div class="top_text">历史版本列表</div>
      <div @click="drawer = false">
        <i class="el-icon-error"></i>
        收起列表
      </div>
    </div>
    <div>
      <el-table :data="gridData" >
        <el-table-column
          property="date"
          label="版本序号"
          width="100"
          align="center"
          type="index"
        ></el-table-column>
        <el-table-column
          property="modifiedTime"
          label="变更时间"
          width="160"
        ></el-table-column>
        <el-table-column
          property="modifiedReason"
          label="变更原因"
          width="200"
        ></el-table-column>
        <el-table-column property="managerName" label="操作人" width="100">
        </el-table-column>
        <el-table-column label="操作"   align="center">
          <template slot-scope="scope">
            <el-button
              type="success"
              icon="el-icon-circle-check"
              plain
              size="mini"
              @click="handleEdit(scope.row.id)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
import * as api from "@/api/zd/contract";

export default {
  name: "history",
  data() {
    return {
      drawer: false,
      gridData: []
    };
  },
  methods: {
    onLoad(number) {
      api
        .contracthistory({ number: number })
        .then(res => {
          
          this.gridData = res.data.data.records;
        })
        .catch(res => {
          
        });
    },
    showhide(number) {
      this.drawer = true;
      this.onLoad(number);
    },
    handleEdit(data) {
      
      this.drawer = false;
      this.$router.push({
        path: "/zd/contractmanage/contractDetail/",
        query: { id: data }
      });
      // this.$emit("bankhistory", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.top_drawer {
  display: flex;
  flex-direction: row;
  background: rgba(245, 245, 245, 1);
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  .top_text {
    font-size: 18px;
    line-height: 45px;
  }
  .top_text + div {
    cursor: pointer;
  }
}
</style>
